import { render, staticRenderFns } from "./BannerItem.vue?vue&type=template&id=35ad9064&scoped=true&"
import script from "./BannerItem.vue?vue&type=script&lang=js&"
export * from "./BannerItem.vue?vue&type=script&lang=js&"
import style0 from "./BannerItem.vue?vue&type=style&index=0&id=35ad9064&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad9064",
  null
  
)

export default component.exports